<template>
	<div class="filters mb-4">
		<div class="row g-3">

			<!-- Post Type selection
			<div class="col col-sm-12 col-md-4 col-lg-3 filter d-flex flex-row justify-content-start align-items-end pt-2"
				v-if="availablePostTypes">
				<div class="dropdown w-100">
					<button class="btn btn-secondary dropdown-toggle w-100" :class="{ show: postTypeDropdownVisible }"
						type="button" id="vueEventsPluginPostTypeDropdownButton" data-bs-toggle="dropdown"
						aria-expanded="false" @click="togglePostTypeDropdown($event)">
						Event Type
					</button>
					<ul id="vueEventsPluginPostTypeDropdown" class="dropdown-menu w-100"
						:class="{ show: postTypeDropdownVisible }" aria-labelledby="vueEventsPluginPostTypeDropdownButton">
						<li v-for="(meta, type) in availablePostTypes" :model="type" :key="type.name">

							<div class="dropdown-item pt-2 pb-1">
								<div class="form-check form-switch mb-0">
									<input class="form-check-input" type="checkbox" :id="switchId(type)" v-model="postTypeCheckboxState"
										:value="type" :aria-describedby="switchId(type)"
										@change="togglePostType(type)">
									<label class="form-check-label" :for="switchId(type)">{{ meta.name }}</label>
								</div>
							</div>

						</li>
					</ul>
				</div>
			</div>
			-->

			<!-- Text search
			<div class="col col-sm-12 col-md-4 col-lg-3 filter d-flex flex-column justify-content-end pt-2">
				<div class="input-group">
					<label :for="componentId('SearchField')" class="form-label visually-hidden">Text search</label>
					<input :id="componentId('SearchField')" type="text" name="filter_search"
						class="form-control rounded-start" placeholder="Search..."
						:aria-describedby="componentId('SearchField')" v-model.lazy.trim="searchInput"
						v-on:change="emitUpdate">
					<div class="input-group-text">
						<i class="fal fa-search"></i>
					</div>
				</div>
			</div>
			-->

			<!-- Taxonomies -->
			<taxonomy-dropdown v-if="'TaxonomyDropdown' === taxComponent" ref="taxonomyDropdownComponent"
				:availableTaxonomyTerms="availableTaxonomyTerms" @update-taxonomy="toggleTaxonomy"
				@close-all-dropdowns="closeAllDropdowns" />

			<!-- Proximity Search -->
			<div v-if="enableProximity" class="col col-sm-12 col-md-4 col-lg-3 filter pt-2">
				<div class="dropdown">
					<button class="btn btn-secondary dropdown-toggle w-100" :class="{ show: proximityDropdownVisible }"
						type="button" id="vueEventsPluginProximityDropdownButton" data-bs-toggle="dropdown"
						aria-expanded="false" @click="toggleProximityDropdown($event)">
						Location
					</button>
					<ul id="vueEventsPluginProximityDropdown" class="dropdown-menu w-100"
						:class="{ show: proximityDropdownVisible }"
						aria-labelledby="vueEventsPluginProximityDropdownButton">
						<li>
							<span class="dropdown-item">
								<proximity-search ref="proximityComponent" @update-proximity="toggleProximity"
									@update-radius="toggleRadius" />
							</span>
						</li>
					</ul>
				</div>
			</div>

			<!-- Ordering and Reset -->
			<div class="col filter d-flex flex-row justify-content-end align-items-end pt-2">
				<button v-if="enableMap" class="btn btn-secondary vue-events-plugin-map-toggle" @click="$emit('toggleMap')">
					Show Map
				</button>
				<div class="dropdown">
					<button class="btn btn-secondary dropdown-toggle ms-2" :class="{ show: orderDropdownVisible }"
						type="button" id="vueEventsPluginOrderDropdownButton" data-bs-toggle="dropdown"
						aria-expanded="false" @click="toggleOrderDropdown($event)">
						Order By
					</button>
					<ul id="vueEventsPluginOrderDropdown" class="dropdown-menu" :class="{ show: orderDropdownVisible }"
						aria-labelledby="vueEventsPluginOrderDropdownButton">
						<li><a class="dropdown-item" :class="{ active: 'ASC' == order && 'title' == orderBy }" href="#"
								v-on:click.prevent.stop="toggleOrder('title', 'ASC')">Title A-Z</a></li>
						<li><a class="dropdown-item" :class="{ active: 'DESC' == order && 'title' == orderBy }" href="#"
								v-on:click.prevent.stop="toggleOrder('title', 'DESC')">Title Z-A</a></li>
						<!--		
						<li><a class="dropdown-item" :class="{ active: 'ASC' == order && 'event_start_date' == orderBy }"
								href="#" v-on:click.prevent.stop="toggleOrder('event_start_date', 'ASC')">Start Date
								Soonest</a></li>
						<li><a class="dropdown-item" :class="{ active: 'DESC' == order && 'event_start_date' == orderBy }"
								href="#" v-on:click.prevent.stop="toggleOrder('event_start_date', 'DESC')">Start Date
								Latest</a></li>
						<li><a class="dropdown-item" :class="{ active: 'ASC' == order && 'rand' == orderBy }" href="#"
								v-on:click.prevent.stop="toggleOrder('rand', 'ASC')">Random</a></li>
						<li v-if="proximity"><a class="dropdown-item"
								:class="{ active: 'ASC' == order && 'distance' == orderBy }" href="#"
								v-on:click.prevent.stop="toggleOrder('distance', 'ASC')">Distance - Closest</a></li>
						<li v-if="proximity"><a class="dropdown-item"
								:class="{ active: 'DESC' == order && 'distance' == orderBy }" href="#"
								v-on:click.prevent.stop="toggleOrder('distance', 'DESC')">Distance - Furthest</a></li>
						-->
					</ul>
				</div>
				<a class="btn btn-primary ms-2" href="#" v-on:click.prevent.stop="toggleReset()">Reset</a>
			</div>
		</div>
	</div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import TaxonomyDropdown from '@/components/TaxonomyDropdown.vue';

export default {
	name: 'EventFilters',
	props: {
		availablePostTypes: Object,
		availableTaxonomyTerms: Object,
		defaultQuery: Object,
	},
	components: {
		TaxonomyDropdown,
		ProximitySearch: defineAsyncComponent(() => import(/* webpackChunkName: "ProximitySearch" */ '@/components/ProximitySearch.vue')),
	},
	inject: [
		'useToggleSubstitutes'
	],
	emits: ['updateFilters', 'toggleMap'],
	expose: ['triggerFilterReload', 'closeAllDropdowns'],
	data() {
		return {
			taxComponent: process.env.VUE_APP_TAX_FILTER_COMPONENT || 'TaxonomyDropdown',
			postTypeDropdownVisible: false,
			orderDropdownVisible: false,
			proximityDropdownVisible: false,
			order: this.$route.query['order'] || 'ASC',
			orderBy: this.$route.query['order-by'] || 'title',
			searchInputValue: this.$route.query['search'] || null,
			postTypes: [],
			taxonomies: [],
			enableMap: ('1' === process.env.VUE_APP_SHOW_MAP || false),
			enableProximity: ('1' === process.env.VUE_APP_PROXIMITY_SEARCH || false),
			proximity: this.$route.query['proximity'] || null,
			proximityRadius: this.$route.query['radius'] || '20',
			postTypeCheckboxState: []
		}
	},
	computed: {
		searchInput: {
			get() {
				return this.$route.query['search'] || this.searchInputValue
			},
			set(value) {
				this.searchInputValue = value;
			},
		},
	},
	methods: {
		switchId(append) {
			return 'vueEventsPluginPostTypeSwitch' + append
		},
		async triggerFilterReload() {
			this.emitUpdate(true)
		},
		emitUpdate(append = true) {
			const defaultQuery = this.defaultQuery || {}

			let taxQuery = {}

			if (this.taxonomies) {
				Object.keys(this.taxonomies).forEach((taxonomy) => {
					taxQuery[taxonomy + '[]'] = this.taxonomies[taxonomy]
				});
			}

			console.log('emitUpdate:append', append)

			this.$emit(
				'updateFilters',
				{
					...defaultQuery,
					...taxQuery,
					search: this.searchInputValue,
					order: this.order,
					'order-by': this.orderBy,
					'post-types[]': this.postTypes,
					proximity: this.proximity,
					radius: this.proximityRadius
				},
				(append) ? true : false
			)
		},
		componentId(append) {
			return 'vueEventsPlugin' + append
		},
		togglePostTypeDropdown(e) {
			if (false === this.useToggleSubstitutes) {
				return
			}
			let currentState = this.postTypeDropdownVisible
			this.closeAllDropdowns(true)
			this.postTypeDropdownVisible = !currentState
			e.stopPropagation()
		},
		toggleOrderDropdown(e) {
			if (false === this.useToggleSubstitutes) {
				return
			}
			let currentState = this.orderDropdownVisible
			this.closeAllDropdowns(true)
			this.orderDropdownVisible = !currentState
			e.stopPropagation()
		},
		toggleProximityDropdown(e) {
			if (false === this.useToggleSubstitutes) {
				return
			}
			let currentState = this.proximityDropdownVisible
			this.closeAllDropdowns(true)
			this.proximityDropdownVisible = !currentState
			e.stopPropagation()
		},
		toggleProximity(latitude, longitude) {
			if (latitude && longitude) {
				this.proximity = latitude + ',' + longitude
				this.order = 'ASC'
				this.orderBy = 'distance'
			} else {
				this.proximity = null
			}
			// if (this.useToggleSubstitutes) {
			// 	this.proximityDropdownVisible = false;
			// }
			this.emitUpdate()
		},
		toggleRadius(distance) {
			this.proximityRadius = distance
			this.emitUpdate()
		},
		toggleOrder(orderBy, order) {
			this.order = order
			this.orderBy = orderBy
			if (this.useToggleSubstitutes) {
				this.orderDropdownVisible = false
			}
			this.emitUpdate()
		},
		toggleReset() {
			if (this.useToggleSubstitutes) {
				this.postTypeDropdownVisible = false
				this.orderDropdownVisible = false
				this.proximityDropdownVisible = false
			}
			this.postTypes = []
			this.postTypeCheckboxState = []
			this.taxonomies = []
			this.order = 'ASC'
			this.orderBy = 'title'
			this.searchInputValue = null
			this.proximity = null
			this.proximityRadius = '20'
			if (this.$refs.taxonomyDropdownComponent) {
				this.$refs.taxonomyDropdownComponent.reset()
			}
			if (this.$refs.proximityComponent) {
				this.$refs.proximityComponent.reset()
			}
			this.emitUpdate(false)
		},
		togglePostType(type) {
			if (this.postTypes.includes(type)) {
				let newTypes = []
				this.postTypes.forEach(t => {
					if (t === type) {
						return
					}
					newTypes.push(t)
				});
				this.postTypes = newTypes
			} else {
				this.postTypes.push(type)
			}
			if (this.useToggleSubstitutes) {
				this.postTypeDropdownVisible = false
			}
			this.emitUpdate()
		},
		toggleTaxonomy(taxonomy, termId) {
			if (this.taxonomies[taxonomy] && this.taxonomies[taxonomy].includes(termId)) {
				let newTerms = []
				this.taxonomies[taxonomy].forEach(t => {
					if (t === termId) {
						return
					}
					newTerms.push(t)
				});
				this.taxonomies[taxonomy] = newTerms
			} else {
				if (this.taxonomies[taxonomy]) {
					this.taxonomies[taxonomy].push(termId)
				} else {
					this.taxonomies[taxonomy] = [termId]
				}
			}
			this.emitUpdate()
		},
		async updateRouteFilters() {

			// Prefill post types from routes
			if ('undefined' !== typeof this.$route.query['post-types[]']) {
				let types = this.$route.query['post-types[]']
				if (false === Array.isArray(types)) {
					types = [types]
				}
				this.postTypes = types
				types.forEach((type) => {
					this.postTypeCheckboxState.push(type)
				})
			}

			// Prefill taxonomies from routes
			if (this.availableTaxonomyTerms) {
				Object.keys(this.availableTaxonomyTerms).forEach((taxonomy) => {
					if ('undefined' === typeof this.$route.query[taxonomy + '[]']) {
						return
					}
					let terms = this.$route.query[taxonomy + '[]']
					if (false === Array.isArray(terms)) {
						terms = [terms]
					}
					this.taxonomies[taxonomy] = terms
				})
			}

		},
		closeAllDropdowns(emit = false) {
			if (this.useToggleSubstitutes) {
				this.postTypeDropdownVisible = false
				this.orderDropdownVisible = false
				this.proximityDropdownVisible = false
			}
			if (emit && this.$refs.taxonomyDropdownComponent) {
				this.$refs.taxonomyDropdownComponent.closeAllDropdowns()
			}
		}
	},
	async created() {
		await this.updateRouteFilters()
	},
	mounted() {
		if (true === this.useToggleSubstitutes) {
			document.body.addEventListener('click', () => {
				if (this.postTypeDropdownVisible) {
					this.postTypeDropdownVisible = false;
				}
				if (this.orderDropdownVisible) {
					this.orderDropdownVisible = false;
				}
				if (this.proximityDropdownVisible) {
					this.proximityDropdownVisible = false;
				}
			})
			const dropdownClickElements = [
				document.getElementById('vueEventsPluginOrderDropdown'),
				document.getElementById('vueEventsPluginProximityDropdown'),
				document.getElementById('vueEventsPluginPostTypeDropdown')
			]
			dropdownClickElements.forEach((element) => {
				if (element) {
					element.addEventListener('click', (e) => {
						e.stopPropagation()
					})
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.input-group-text {
	cursor: pointer;
}
</style>
